import styled from "styled-components";
import { Check } from "@mui/icons-material";
import { Step, StepConnector, StepLabel, Stepper, SvgIcon } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledStepperHorizontal = styled(Stepper)`
    box-sizing: border-box;
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    padding: 18px;
    background-color: transparent;
    border: 1px solid var(--color-grey-700);
    border-radius: var(--radius-5);
    @media ${breakpoints.sm} {
        justify-content: space-evenly;
    }
    @media ${breakpoints.xs} {
        padding: 18px 8px;
    }
`;

export const StyledStep = styled(Step)`
    @media ${breakpoints.xs} {
        padding-left: 0;
        padding-right: 0;
    }
`;

export const StyledStepConnector = styled(StepConnector)`
    flex: none !important;
    border-width: 0;
`;

export const StyledStepLabel = styled(StepLabel)`
    margin-left: 8px;
    @media ${breakpoints.xs} {
        margin-left: 0px;
    }
    color: var(--color-grey-800);
    .steplabel-label {
        @media ${breakpoints.xs} {
            display: none;
        }
    }

    .steplabel-active {
        color: var(--color-secondary);
    }
    .steplabel-completed {
        color: var(--color-primary);
    }
    .MuiStepLabel-iconContainer {
        @media ${breakpoints.xs} {
            padding-right: 0;
        }
    }
`;

export const StyledStepIcon = styled(SvgIcon)<{ $active: boolean }>`
    width: 45px;
    height: 45px;
    @media ${breakpoints.sm} {
        width: 35px;
        height: 35px;
    }
    circle {
        fill: transparent;
        stroke: ${(props) => (props.$active ? "var(--color-secondary)" : "var(--color-grey-700)")};
    }
    text {
        font-size: var(--size-8);
        color: ${(props) => (props.$active ? "var(--color-secondary)" : "var(--color-grey-800)")};
    }
`;

export const StyledCompletedStepIcon = styled(Check)`
    width: 15px;
    height: 15px;
    padding: 15px;
    font-size: var(--size-8);
    background-color: var(--color-secondary);
    border-radius: var(--radius-50);
    fill: white;
    @media ${breakpoints.sm} {
        padding: 10px;
    }
`;
